function kgUpdateBaseDur(kgVariant) {
  const kgEls = document.querySelectorAll('.kg-selected-duration-value');
  if (!kgEls.length || !kgVariant?.option1) return;
  kgEls.forEach(el => {
    el.textContent = kgVariant.option1;
  });
}

document.addEventListener('variant:changed', (event) => {
  kgUpdateBaseDur(event.detail.variant);
});


document.querySelector('.kb-addon-checkbox')?.addEventListener('change', function () {
  const yesOption = document.querySelector(
    '.kg-product-option-massage-table-rental input[value="Yes — Add Table Rental (+$60)"]'
  );

  const noOption = document.querySelector(
    '.kg-product-option-massage-table-rental input[value="No Thanks"]'
  );

  const targetOption = this.checked ? yesOption : noOption;

  if (targetOption) {
    targetOption.checked = true;
    targetOption.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

const checkbox = document.querySelector('.kb-addon-checkbox');
const yesOption = document.querySelector(
  '.kg-product-option-massage-table-rental input[value="Yes — Add Table Rental (+$60)"]'
);

if (checkbox && yesOption) {
  checkbox.checked = yesOption.checked;
}